import React from "react";
import autobind from "autobind-decorator";
import { connect } from "react-redux";
import moment from "moment-jalaali";

import services from "core/services";

import {
  PureComponent,
  Serialize,
  Description,
  GroupBox
} from "core/components";
import {
  Row,
  Col,
  List,
  ListInput,
  Radio,
  Button,
  CardContent,
  Icon
} from "core/components/Framework7";
import { setPaymentType, gift } from "content/pages/OrderStep/Module";

import { StepsTab } from "./Components/StepsTab";

import classes from "./styles.module.css";
import { Toggle } from "framework7-react";

const Price = Serialize.Price;

class PaymentType extends PureComponent {
  constructor(props) {
    super(props);

    const view = this.$f7.views.get("#view-cart");
    this.router = view && view.router;

    this.state = {
      value: null,
      isUsingCredit: false,
      creditDefaultId: 4,// آیدی پیشفرض مخصوص پرداخت اعتباری که باید برای سرور بفرستیم
      paymentOptionId: null,
      paymentMethodsOptions: [],
      giftCode: null,
      giftStatus: false,
      giftQuantity: 0,
      regularDeliveryDuration: null,
      expressDeliveryDuration: null,
      regularDeliveryPrice: null,
      expressDeliveryPrice: null,
      billingMethods: []
      // sumAfter: null,
    };
  }

  componentDidMount() {
    this.getPaymentTypes();
  }

  // componentDidUpdate(prevProps, prevState) {
  //   if (his.props.order = prevProps.order) {
  //     return;
  //   }

  //   this.setState({})
  // }

  get initialValue() {
    const { env } = this.props;

    return {
      delivery: env && env.delivery
    };
  }

  setGift() {
    const { order, price } = this.props;
    const { giftCode } = this.state;

    this.$f7.dialog.preloader("در حال ارسال اطلاعات");

    const id = order.id;

    const params = {
      store: 2
    };

    this.props
      .gift(id, giftCode, params)
      .then(r => {
        this.setState({ giftStatus: true, giftQuantity: 0 });
      })
      .catch(r => {
        this.setState({ giftStatus: false });
        this.$f7.dialog.alert("کد تخفیف اعمال شده صحیح نمی باشد", "کد اشتباه");
      })
      .finally(r => {
        this.$f7.dialog.close();
      });
  }

  getPaymentTypes() {
    this.$f7.dialog.preloader("در حال دریافت اطلاعات");

    services.ecommerce.Order.getPaymentTypes()
      .then(r => {
        const { order } = this.props;
        const billingMethods = r.data.billingMethods;

        if (!order || !billingMethods || billingMethods.length == 0) return;

        // console.log('order:', order, 'billingMethods:', billingMethods, "rrrr", r);

        let paymentTypeId = billingMethods[0].id;

        if (order.billingInfo) {
          const orderPaymentTypeId = order.billingInfo.methodId;
          for (const paymentType of billingMethods) {
            if (paymentType.id == orderPaymentTypeId) {
              paymentTypeId = orderPaymentTypeId;
              break;
            }
          }
        }

        //ToDo برای مقدار اولیه دادن به بانک های برای انتخاب شدن
        // const onlinePeyment = billingMethods?.find(f => f.typeAlias == "online");
        // let defaultOptionId;
        // if (onlinePeyment) {
        //   const methodOptionsList = onlinePeyment?.methodOptions;

        //   defaultOptionId = methodOptionsList ? methodOptionsList[0].id : null
        // }

        this.setState({
          value: paymentTypeId,
          billingMethods: billingMethods,
          // paymentOptionId: defaultOptionId ?? null
        });
      })
      .catch(e => { })
      .finally(r => {
        this.$f7.dialog.close();
      });
  }

  handleNext() {
    const { order } = this.props;

    this.$f7.dialog.preloader("در حال ارسال اطلاعات");

    const id = order.id;

    const params = {
      store: 2
    };

    //TODO main model
    const paymentOptionId = this.state.paymentOptionId || null;
    const creditId = this.state.isUsingCredit && { method_id: this.state.creditDefaultId };
    const methodId = paymentOptionId || this.state.value || 1;

    const paymentsArray = creditId ? [{ method_id: methodId }, { method_id: creditId }] : [{ method_id: methodId }];


    const model = {
      payments: paymentsArray
    };
    // const paymentOptionId = this.state.paymentOptionId || null;
    // const methodId = paymentOptionId || this.state.value || 1;

    // const model = {
    //   method_id: methodId
    // };

    this.props
      .setPaymentType(id, model, params)
      .then(r => {
        // this.props.navigate.navigate('/step/finalize', { props: { navigate: this.props.navigate } })
        this.router && this.router.navigate("/step/finalize");
      })
      .finally(r => {
        this.$f7.dialog.close();
      });
  }

  changePaymentType(e) {
    const valueNumber = parseInt(e.target.value);
    const selectedPayments = this.state.billingMethods?.find(
      f => f.id == valueNumber
    );

    const { children } = selectedPayments;

    this.setState({
      value: valueNumber,
      paymentOptionId: children ? children[0].id : null,
      paymentMethodsOptions: children || []
    });
    // this.setState({
    //   value: parseInt(e.target.value)
    // });
  }

  changePaymentOption(e) {
    // const valueNumber = parseInt(e.target.value);
    this.setState({
      paymentOptionId: parseInt(e.target.value)
    });
  }

  //تابع زمانی فراخوانی میشود که دکمه استفاده از اعتبار ،تغییر وضعیت بدهد
  changeCreditType(e) {
    this.setState({
      isUsingCredit: !e
    }, () => {
      if (this.state.isUsingCredit) {
        this.reRenderOrderWithCredit();
      }
    });

  }

  reRenderOrderWithCredit() {
    const { order } = this.props;

    this.$f7.dialog.preloader("در حال ارسال اطلاعات");

    const id = order.id;

    const params = {
      store: 2
    };

    const paymentOptionId = this.state.paymentOptionId || null;
    const creditId = this.state.isUsingCredit && { method_id: this.state.creditDefaultId };
    const methodId = paymentOptionId || this.state.value || 1;

    const paymentsArray = creditId ? [{ method_id: methodId }, { method_id: creditId }] : [{ method_id: methodId }];


    const model = {
      payments: paymentsArray
    };


    // const model = {
    //   // method_id: this.state.value,
    //   method_id: this.state.value || 1,
    //   options: this.state.isUsingCredit ? "credit" : ""
    // };
    // const model = {
    //   payments: [
    //     { method_id: this.state.creditDefaultId },
    //     { method_id: this.state.value }
    //   ]
    // };

    this.props
      .setPaymentType(id, model, params)
      .then(r => {

        // this.setState({

        // });
        // console.log("res props", r);
        // this.props.navigate.navigate('/step/finalize', { props: { navigate: this.props.navigate } })
        // this.router && this.router.navigate("/step/finalize");
      })
      .catch(error => {
        this.$f7.dialog.alert(error?.message);
      })
      .finally(r => {
        this.$f7.dialog.close();
      });
  }

  changeGiftCode(e) {
    this.setState({
      giftCode: e.target.value.toString().toUpperCase()
    });
  }

  renderPaymentTypes() {
    const billingMethods = this.state.billingMethods;
    // console.log(billingMethods)
    // const billingMethods = [{id: 1, title: 'محل'}, {id: 2, title: 'پرداختی'}] /* test */

    return billingMethods.map((method, index) => {
      return this.renderPaymentType(method, index);
    });
  }


  renderPaymentType(method, index) {
    const { value } = this.state;
    const defChecked = method.id == value;

    return (
      <Row key={method.id} className={classes.paymentTypeRadio}>
        <Radio
          name="payment-option"
          value={method.id}
          checked={defChecked}
          onChange={this.changePaymentType}
        />
        {method.title}
      </Row>
    );
  }

  renderOnlinePaymentOptions() {
    const paymentMethodsOptions = this.state.paymentMethodsOptions;

    return paymentMethodsOptions.map((model, index) => {
      return this.renderOnlinePaymentOption(model, index);
    });
  }

  renderOnlinePaymentOption(option, index) {
    const { paymentOptionId } = this.state;
    const defChecked = option.id == paymentOptionId;
    // console.log(" payoptionId state", paymentOptionId);
    // console.log(" payoptionId", option.id);


    return (
      <Row key={option.id} className={classes.paymentTypeRadio}>
        <Radio
          name="payment_type"
          value={option.id}
          checked={defChecked}
          onChange={this.changePaymentOption}
        />
        {option.title}
      </Row>
    );
  }

  renderDelivery(deliveryTypes) {
    console.log("env.delivery", deliveryTypes)
    const { order } = this.props;


    const nowMoment = moment();
    const nowWeekDayNo = nowMoment.day();
    const tomorrowWeekDayNo = nowMoment.add(1, "d").day();
    // const templateMoment = moment(order.shippingInfo.deliverDateFrom);
    // console.log("templateMoment now", templateMoment.day())

    let deliverDateFrom = null;
    let deliverDateTo = null;
    let isTomorrow = false;
    // console.log('nowWeekDayNo:', nowWeekDayNo)
    // console.log('tomorrowWeekDayNo:', tomorrowWeekDayNo)
    // console.log('deliveries:', deliveryTypes, typeof deliveryTypes)

    let delivery = null;
    let deliveryTom = null;

    for (const d of deliveryTypes) {
      // console.log('d:', d)
      if (!delivery && d.dayOfWeek.includes(nowWeekDayNo)) delivery = d;

      if (!deliveryTom && d.dayOfWeek.includes(tomorrowWeekDayNo))
        deliveryTom = d;

      if (delivery && deliveryTom) break;
    }

    // display message => we can't delivery any orders now
    if (!delivery) {
      return <span />;
    }

    // console.log('delivery:', delivery)

    const dateFrom = moment(
      nowMoment.format("YYYY-MM-DD") + " " + delivery.time.from,
      "YYYY-MM-DD HH:mm"
    );
    const dateFromTom = moment(
      nowMoment.format("YYYY-MM-DD") + " " + deliveryTom.time.from,
      "YYYY-MM-DD HH:mm"
    );
    const dateTo = moment(
      nowMoment.format("YYYY-MM-DD") + " " + delivery.time.to,
      "YYYY-MM-DD HH:mm"
    );
    // console.log('dateFrom:', dateFrom, '- dateTo:', dateTo)

    const dur = delivery.types[0].duration;
    if (nowMoment.isSameOrBefore(dateFrom)) {
      // today
      deliverDateFrom = dateFrom;
      deliverDateTo = deliverDateFrom.clone().add(dur, "m");
    } else if (nowMoment.isSameOrAfter(dateTo)) {
      // tomorrow
      deliverDateFrom = dateFromTom;
      deliverDateTo = deliverDateFrom
        .clone()
        .add(1, "d")
        .add(dur, "m");
      isTomorrow = true;
    } else {
      // to time
      deliverDateFrom = nowMoment;
      deliverDateTo = deliverDateFrom.clone().add(dur, "m");
    }

    return (
      <Col width="100" className={classes.deliveryType}>
        <span>{`- زمان تحویل `}</span>
        <strong>{isTomorrow ? "فردا" : "امروز"}</strong>
        <span>{" از ساعت "}</span>
        <strong>{deliverDateFrom.format("HH:mm")}</strong>
        <span>{" تا ساعت "}</span>
        <strong>{deliverDateTo.format("HH:mm")}</strong>
      </Col>
    );
  }

  renderDeliveryNew() {
    const { order } = this.props;

    if (!order) return <span />;

    const { shippingInfo } = order;
    const deliverDateFrom = shippingInfo && shippingInfo.deliverTimeFrom;
    const deliverDateTo = shippingInfo && shippingInfo.deliverTimeTo;
    const weekdaynames = ["یکشنبه", "دوشنبه", "سه شنبه", "چهارشنبه", "پنج شنبه", "جمعه", "شنبه"];
    // console.log("weekdaynames", weekdaynames)

    const nowMoment = moment();
    const tomorrowMoment = moment().add(1, "d");

    const deliverDateFromMoment = moment(deliverDateFrom);
    const deliverDateToMoment = moment(deliverDateTo);

    const nowWeekDayNo = nowMoment.day();
    const tomorrowWeekDayNo = tomorrowMoment.day();
    const deliverDateFromDayNo = deliverDateFromMoment && deliverDateFromMoment.day();
    const deliverDateToDayNo = deliverDateToMoment && deliverDateToMoment.day();

    // console.log("bool nowWeekDayNo == deliverDateFromDayNo ", nowWeekDayNo == deliverDateFromDayNo);
    // console.log("nowMoment.dayOfYear() ", nowMoment.dayOfYear());
    // console.log("tomorrowWeekDayNo", tomorrowWeekDayNo);
    // console.log("deliverDateFromMoment.dayOfYear()", deliverDateFromMoment.dayOfYear());
    // console.log("bool nowMoment.dayOfYear() == deliverDateFromMoment.dayOfYear()", nowMoment.dayOfYear() == deliverDateFromMoment.dayOfYear())


    let deliveyDay
    if (nowWeekDayNo == deliverDateFromDayNo && nowMoment.dayOfYear() == deliverDateFromMoment.dayOfYear()) {
      deliveyDay = "امروز";
      // deliveryTimeFrom = deliverDateFromMoment.clone();

    } else if (tomorrowWeekDayNo == deliverDateFromDayNo && tomorrowMoment.dayOfYear() == deliverDateFromMoment.dayOfYear()) {
      deliveyDay = "فردا";

    } else {
      deliveyDay = ` روز ${weekdaynames[deliverDateFromDayNo]} ${deliverDateFromMoment && deliverDateFromMoment.format("jYYYY/jM/jD")}`;

    }


    return (
      <Col width="100" className={classes.deliveryType}>
        <span>{`- زمان تحویل `}</span>
        <strong>{deliveyDay}</strong>
        <span>{" از ساعت "}</span>
        <strong>{deliverDateFromMoment && deliverDateFromMoment.format("HH:mm")}</strong>
        <span>{" تا ساعت "}</span>
        <strong>{deliverDateToMoment && deliverDateToMoment.format("HH:mm")}</strong>
      </Col>
    );
  }


  handleDeliveryPrice() {
    // const { regularDeliveryPrice } = this.initialValue;
    const { order } = this.props;
    // console.log("order", order)
    if (!order) {
      return (
        <Col width="100" className={classes.deliveryType}>
          <span>- هزینه ارسال:</span>
          <strong>
            {" "}
            نامشخص
          </strong>
        </Col>
      );
    }
    // console.log(`regularDeliveryPrice is ${regularDeliveryPrice}`)
    // console.log("order is", order)

    return (
      <Col width="100" className={classes.deliveryType}>
        <span>- هزینه ارسال:</span>
        <strong>
          {" "}
          {(order.shippingInfo && order.shippingInfo.price && (
            <Price price={order.shippingInfo.price} />
            // <Price price={regularDeliveryPrice} />
          )) || "رایگان"
          }
        </strong>
      </Col>
    );
  }

  render() {
    const { value, giftCode, giftStatus } = this.state;
    const { order, price, user } = this.props;


    const env = this.initialValue;

    // console.log('env:', env)
    // console.log('order:', order)
    // console.log('price:', price)

    return (
      <div className={classes.container}>
        <StepsTab step={2} />

        <div className={`${classes.pagePadding}`}>
          {order && order.giftId && order.gift ? (
            <Row noGap className={classes.giftShow}>
              <Col>
                <Button fill large className={classes.giftShow}>
                  {"مبلغ "}
                  <Price price={order.gift.value} hasExtension={true} />
                  {" تخفیف اعمال شد"}
                </Button>
              </Col>
            </Row>
          ) : (
            <Row noGap className={classes.giftBox}>
              <Col width={70}>
                <List>
                  <ListInput
                    type="text"
                    placeholder="کد تخفیف خود را وارد کنید."
                    clearButton
                    onInputClear={() => this.setState({ giftCode: "" })}
                    onChange={this.changeGiftCode}
                  />
                </List>
              </Col>
              <Col width={30}>
                <Button
                  large
                  fill
                  text={"اعمال"}
                  disabled={!giftCode || giftCode.trim().length === 0}
                  onClick={this.setGift}
                />
              </Col>
            </Row>
          )}

          <GroupBox title={"روش پرداخت"} outline>
            <CardContent>{this.renderPaymentTypes()}</CardContent>

            <CardContent>{this.renderOnlinePaymentOptions()}</CardContent>
          </GroupBox>

          {
            user && user.currentCredit && user.currentCredit > 0 ?
              <GroupBox title={"استفاده از اعتبار"} outline>
                <CardContent>
                  <Row>
                    <Col width="66">
                      <Toggle
                        checked={this.state.isUsingCredit}
                        onToggleChange={e => this.changeCreditType(e)}>
                      </Toggle>
                      <span className={classes.creditDes}>کسر مبلغ اعتبار از فاکتور نهایی</span>
                    </Col>
                    <Col width="33" className={classes.creditValue}>
                      <p className="">مبلغ اعتبار :</p>
                      <p className="">{user.currentCredit}</p>
                    </Col>
                  </Row>
                </CardContent>
              </GroupBox> : null
          }


          <GroupBox title={"زمان تحویل"} outline>
            <CardContent>{this.renderDeliveryNew()}</CardContent>
            {/* <CardContent>{this.renderDelivery(env.delivery)}</CardContent> */}
          </GroupBox>

          <GroupBox title={"هزینه تحویل"} outline>
            <CardContent>{this.handleDeliveryPrice()}</CardContent>
          </GroupBox>

          {/*  */}
          <Description
            delivery={order && order.shippingInfo && order.shippingInfo.price}
            sumBefore={price && price.sumBefore}
            sumOfDiscounts={price && price.sumOfDiscounts}
            sumAfter={price && price.sumAfter}
            gift={order && order.giftId && order.gift && order.gift.value}
          />
        </div>

        <Button
          large
          fill
          icon="mdi-arrow-left"
          text={"مرحله بعد"}
          className={classes.nextButton}
          onClick={() => this.handleNext()}
        />
      </div>
    );
  }
}

export default connect(
  state => ({
    order: state.Order.order,
    price: state.Order.price,
    user: state.General.user,
    env: state.General.env
  }),
  {
    setPaymentType,
    gift
  }
)(autobind(PaymentType));
